<template>
	<div class="pa-6">
		<a-hotel-select
			v-model="hotelCode"
			:hotels="hotels">
		</a-hotel-select>
		<v-tabs
			v-model="currentTab"
			slider-color="secondary"
			dark
			grow>
			<v-tab
				v-for="(tab, tabKey) in tabs"
			   	:key="tabKey"
			   	ripple>
				   <!-- :to="tab.to" -->
				{{ tab.name }}
			</v-tab>

			<v-tabs-items v-model="currentTab">

				<v-tab-item
					:key="0"
					:transition="false"
					:reverse-transition="false">
					<reserves
						:hotelCode="hotelCode"
						:minMonth="minMonth">
					</reserves>
				</v-tab-item>

				<v-tab-item
					:key="1"
					:transition="false"
					:reverse-transition="false">
					<addons
						:hotelCode="hotelCode"
						:minMonth="minMonth">
					</addons>
				</v-tab-item>

				<v-tab-item
					:key="2"
					:transition="false"
					:reverse-transition="false">
					<corrections
						:hotelCode="hotelCode">
					</corrections>
				</v-tab-item>

			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
	import reserves from './Reserves.vue'
	import addons from './Addons.vue'
	import corrections from './Corrections.vue'
	import aHotelSelect from '../base/AHotelSelect.vue'
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
			reserves,
			addons,
			corrections,
			aHotelSelect
		},
		data: () => ({
			tabs: [
				{
					name: 'Резервы'
				},
				{
					name: 'Дополнения'
				},
				{
					name: 'Коррекции'
				},
			],
			currentTab: 0,
			hotels: [],
			hotelCode: '',
		}),
		computed: {
			minMonth() {
				return this.hotels.find(hotel => hotel.code == this.hotelCode).month
			},
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code

			this.getReportMonths()
		},
		methods: {
			getReportMonths() {
				api.post('pl/get_pending_report_month', {
					hotels: this.hotels
				})
				.then(response => {

					this.hotels = response.data.hotels

				}, error => {})
			}
		}
	}
</script>
